var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarNotificationBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1639 19.085C13.6612 19.0997 14.1495 19.221 14.5953 19.4406H14.6221C14.9946 19.7445 15.0578 20.2868 14.7653 20.6673C14.2325 21.4297 13.3801 21.9104 12.4482 21.974C11.4907 22.0882 10.5265 21.8231 9.76425 21.2362C9.37223 20.9674 9.11748 20.5423 9.06643 20.0717C9.06643 19.5739 9.53164 19.3428 9.96107 19.245C10.464 19.1391 10.9767 19.0855 11.4909 19.085H13.1639ZM12.0366 2C15.1321 2 18.3259 4.24008 18.6569 7.48463C18.7106 8.15132 18.6569 8.84468 18.7106 9.52026C18.8862 10.3915 19.2906 11.2011 19.8826 11.867C20.2506 12.4143 20.4638 13.0498 20.4999 13.7071V13.9115C20.5054 14.7984 20.1876 15.6573 19.6052 16.3294C18.8671 17.1186 17.8657 17.6145 16.7871 17.725C13.6005 18.1339 10.3743 18.1339 7.1877 17.725C6.09645 17.6229 5.0809 17.1263 4.33382 16.3294C3.76973 15.6508 3.47393 14.7912 3.50181 13.9115V13.7071C3.53672 13.0523 3.74336 12.4179 4.10121 11.867C4.69585 11.2005 5.10588 10.3918 5.29107 9.52026C5.34475 8.84468 5.29107 8.16021 5.34475 7.48463C5.68471 4.24008 8.81593 2 11.9472 2H12.0366Z",
    fill: "#228BE6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNotificationBlue);
export default __webpack_public_path__ + "static/media/sidebar_notification_blue.5cdee2e653b27fb32ff2f8fa8db1914b.svg";
export { ForwardRef as ReactComponent };